<template>
  <div class="wrap">
    <div v-if="!['A', 'E', 'I'].includes(productType)" class="content">
      <div v-for='(item,index) in teethOne' :key="index" class="teeth" @click="teethClick(index,item,'one')">
        <span>{{ item.number }}</span>
        <el-popover
            ref="onePopover"
            :disabled="readOnly || !selectTeethFn(item.number, selectOne)"
            placement="bottom"
            trigger="click"
            @after-leave="popoverHide(index, 'one', item)">
          <div class="flex-y-c">
            <el-select v-model="item.spacingType" :placeholder="$t('cases.createDiagnosis.controlgap')"
                       size="medium"
                       style="width: 2.2rem" @change="(val) => selectChange(val,item,'teethOne',selectOne)">
              <el-option
                  v-for="it in options"
                  :key="it.value"
                  :label="it.label"
                  :value="it.value">
              </el-option>
            </el-select>
            <div :class="{'active_btn': item['maintain']}" class="ml20 wc_btn"
                 @click="selectChange('maintain',item,'teethOne', selectOne)">{{ $t('cases.createDiagnosis.wcjx') }}
            </div>
          </div>
          <div class="interval_input">
            <div v-show="item.spacingType === '1' || item.spacingType === '2'" class="posr">
              <el-input v-model="item.width"
                        :placeholder="{
                          '1': $t('cases.createDiagnosis.kdjxz'),
                          '2': $t('cases.createDiagnosis.sxjxz')
                        }[item.spacingType]"
                        :value="item.width"
                        class="input_width"
                        @change="disposeNumber({key: item, value: arguments[0]})"
                        @input="disposeNumber({key: item, value: arguments[0]})"></el-input>
              <span class="input_mm">mm</span>
            </div>
          </div>
          <div v-if="index !== teethOne.length - 1" slot="reference" :class="teethClass(item)" class="com_img"
               @click="resetNumber(item,'teethOne',index)"></div>
        </el-popover>
      </div>
    </div>
    <div v-if="!productType ||  ['B','C', 'G', 'H', 'I'].includes(productType)" class="content">
      <div v-for='(item,index) in teethTow' :key="index" class="teeth" @click="teethClick(index,item,'two')">
        <span>{{ item.number }}</span>
        <el-popover
            ref="twoPopover"
            :disabled="readOnly || !selectTeethFn(item.number, selectTow)"
            placement="bottom"
            trigger="click"
            @after-leave="popoverHide(index, 'two', item)">
          <div class="flex-y-c">
            <el-select v-model="item.spacingType" :placeholder="$t('cases.createDiagnosis.controlgap')"
                       size="medium"
                       style="width: 2.2rem" @change="(val) => selectChange(val,item,'teethTow',selectTow)">
              <el-option
                  v-for="it in options"
                  :key="it.value"
                  :label="it.label"
                  :value="it.value">
              </el-option>
            </el-select>
            <div :class="{'active_btn': item['maintain']}" class="ml20 wc_btn"
                 @click="selectChange('maintain',item,'teethTow', selectTow)">{{ $t('cases.createDiagnosis.wcjx') }}
            </div>
          </div>
          <div class="interval_input">
            <div v-show="item.spacingType === '1' || item.spacingType === '2'" class="posr">
              <el-input :placeholder="{
                          '1': $t('cases.createDiagnosis.kdjxz'),
                          '2': $t('cases.createDiagnosis.sxjxz')
                        }[item.spacingType]"
                        :value="item.width"
                        class="input_width"
                        @change="disposeNumber({key: item, value: arguments[0]})"
                        @input="disposeNumber({key: item, value: arguments[0]})"></el-input>
              <span class="input_mm">mm</span>
            </div>
          </div>
          <div v-if="index !== teethTow.length - 1" slot="reference" :class="teethClass(item)" class="com_img"
               @click="resetNumber(item,'teethTow',index)"></div>
        </el-popover>
      </div>
    </div>
    <div v-if="!productType || ['B','C', 'G', 'H', 'I'].includes(productType)" class="content">
      <div v-for='(item,index) in teethThree' :key="index" class="teeth" @click="teethClick(index,item,'three')">
        <span>{{ item.number }}</span>
        <el-popover
            ref="threePopover"
            :disabled="readOnly || !selectTeethFn(item.number, selectThree)"
            placement="bottom"
            trigger="click"
            @after-leave="popoverHide(index, 'three', item)">
          <div class="flex-y-c">
            <el-select v-model="item.spacingType" :placeholder="$t('cases.createDiagnosis.controlgap')"
                       size="medium"
                       style="width: 2.2rem" @change="(val) => selectChange(val,item,'teethThree',selectThree)">
              <el-option
                  v-for="it in options"
                  :key="it.value"
                  :label="it.label"
                  :value="it.value">
              </el-option>
            </el-select>
            <div :class="{'active_btn': item['maintain']}"
                 class="ml20 wc_btn"
                 @click="selectChange('maintain',item,'teethThree', selectThree)">{{ $t('cases.createDiagnosis.wcjx') }}
            </div>
          </div>
          <div class="interval_input">
            <div v-show="item.spacingType === '1' || item.spacingType === '2'" class="posr">
              <el-input :placeholder="{
                          '1': $t('cases.createDiagnosis.kdjxz'),
                          '2': $t('cases.createDiagnosis.sxjxz')
                        }[item.spacingType]"
                        :value="item.width"
                        class="input_width"
                        @change="disposeNumber({key: item, value: arguments[0]})"
                        @input="disposeNumber({key: item, value: arguments[0]})"></el-input>
              <span class="input_mm">mm</span>
            </div>
          </div>
          <div v-if="index !== teethThree.length - 1" slot="reference" :class="teethClass(item)"
               class="com_img" @click="resetNumber(item,'teethThree',index)"></div>
        </el-popover>
      </div>
    </div>
    <div v-if="!['A', 'E', 'I'].includes(productType)" class="content">
      <div v-for='(item,index) in teethFour' :key="index" class="teeth" @click="teethClick(index,item,'four')">
        <span>{{ item.number }}</span>
        <el-popover
            ref="fourPopover"
            :disabled="readOnly || !selectTeethFn(item.number, selectFour)"
            placement="bottom"
            trigger="click"
            @after-leave="popoverHide(index, 'four', item)">
          <div class="flex-y-c">
            <el-select v-model="item.spacingType" :placeholder="$t('cases.createDiagnosis.controlgap')"
                       size="medium"
                       style="width: 2.2rem" @change="(val) => selectChange(val,item,'teethFour',selectFour)">
              <el-option
                  v-for="it in options"
                  :key="it.value"
                  :label="it.label"
                  :value="it.value">
              </el-option>
            </el-select>
            <div :class="{'active_btn': item['maintain']}"
                 class="ml20 wc_btn"
                 @click="selectChange('maintain',item,'teethFour', selectFour)">{{ $t('cases.createDiagnosis.wcjx') }}
            </div>
          </div>
          <div class="interval_input">
            <div v-show="item.spacingType === '1' || item.spacingType === '2'" class="posr">
              <el-input :placeholder="{
                          '1': $t('cases.createDiagnosis.kdjxz'),
                          '2': $t('cases.createDiagnosis.sxjxz')
                        }[item.spacingType]"
                        :value="item.width"
                        class="input_width"
                        @change="disposeNumber({key: item, value: arguments[0]})"
                        @input="disposeNumber({key: item, value: arguments[0]})"></el-input>
              <span class="input_mm">mm</span>
            </div>
          </div>
          <div v-if="index !== teethFour.length - 1" slot="reference" :class="teethClass(item)"
               class="com_img" @click="resetNumber(item,'teethFour',index)"></div>
        </el-popover>
      </div>
    </div>
    <div v-if="find(totalTeeth, item => item.spacingType || item.maintain)" class="detail">
      <template v-for="(item, index) in totalTeeth">
        <p v-if="item.spacingType || item.maintain"
           :key="index" class="fz14 main_theme_color_333">
          {{ item.number }},
          {{ item.nextNumber }}
          {{
            isShowText[item.spacingType] || (item.maintain ? $t('cases.createDiagnosis.maintain') : '')
          }}{{ $t('cases.createDiagnosis.spacing') }}
          <span v-if="item.width">{{ item.width }}mm</span>
        </p>
      </template>
    </div>
  </div>
</template>

<script>
import {
  extend,
  map,
  pick,
  filter,
  each,
  pickBy,
  uniq,
  isArray,
  isNumber,
  find
} from "lodash";
import {toNumber} from "../../../common/js/Fn";
import {mapState} from 'vuex';

export default {
  data() {
    return {
      options: [
        {
          label: this.$t('cases.createDiagnosis.kdjx'),
          value: '1'
        },
        {
          label: this.$t('cases.createDiagnosis.sxjx'),
          value: '2'
        },
        {
          label: this.$t('cases.createDiagnosis.gbjx'),
          value: '3'
        },
      ],
      teethOne: [
        {
          number: 55,
          spacingType: '',
        },
        {
          number: 54,
          spacingType: '',
        },
        {
          number: 53,
          spacingType: '',
        },
        {
          number: 52,
          spacingType: '',
        },
        {
          number: 51,
          spacingType: '',
        },
        {
          number: 61,
          spacingType: '',
        },
        {
          number: 62,
          spacingType: '',
        },
        {
          number: 63,
          spacingType: '',
        },
        {
          number: 64,
          spacingType: '',
        },
        {
          number: 65,
          spacingType: '',
        },
      ],
      teethTow: [
        {
          number: 18,
          spacingType: '',
        },
        {
          number: 17,
          spacingType: '',
        },
        {
          number: 16,
          spacingType: '',
        },
        {
          number: 15,
          spacingType: '',
        },
        {
          number: 14,
          spacingType: '',
        },
        {
          number: 13,
          spacingType: '',
        },
        {
          number: 12,
          spacingType: '',
        },
        {
          number: 11,
          spacingType: '',
        },
        {
          number: 21,
          spacingType: '',
        },
        {
          number: 22,
          spacingType: '',
        },
        {
          number: 23,
          spacingType: '',
        },
        {
          number: 24,
          spacingType: '',
        },
        {
          number: 25,
          spacingType: '',
        },
        {
          number: 26,
          spacingType: '',
        },
        {
          number: 27,
          spacingType: '',
        },
        {
          number: 28,
          spacingType: '',
        },
      ],
      teethThree: [
        {
          number: 48,
          spacingType: '',
        },
        {
          number: 47,
          spacingType: '',
        },
        {
          number: 46,
          spacingType: '',
        },
        {
          number: 45,
          spacingType: '',
        },
        {
          number: 44,
          spacingType: '',
        },
        {
          number: 43,
          spacingType: '',
        },
        {
          number: 42,
          spacingType: '',
        },
        {
          number: 41,
          spacingType: '',
        },
        {
          number: 31,
          spacingType: '',
        },
        {
          number: 32,
          spacingType: '',
        },
        {
          number: 33,
          spacingType: '',
        },
        {
          number: 34,
          spacingType: '',
        },
        {
          number: 35,
          spacingType: '',
        },
        {
          number: 36,
          spacingType: '',
        },
        {
          number: 37,
          spacingType: '',
        },
        {
          number: 38,
          spacingType: '',
        },
      ],
      teethFour: [
        {
          number: 85,
          spacingType: '',
        },
        {
          number: 84,
          spacingType: '',
        },
        {
          number: 83,
          spacingType: '',
        },
        {
          number: 82,
          spacingType: '',
        },
        {
          number: 81,
          spacingType: '',
        },
        {
          number: 71,
          spacingType: '',
        },
        {
          number: 72,
          spacingType: '',
        },
        {
          number: 73,
          spacingType: '',
        },
        {
          number: 74,
          spacingType: '',
        },
        {
          number: 75,
          spacingType: '',
        },
      ],
      isShowText: {
        1: this.$t('cases.createDiagnosis.expansion'),
        2: this.$t('cases.createDiagnosis.retraction'),
        3: this.$t('cases.createDiagnosis.closure')
      },
      teethKey: ['teethOne', 'teethTow', 'teethThree', 'teethFour'],
      teethList: [],
      setList: false,
      QUADRANT_MAP: {
        selectOne: {range: [55, 54, 53, 52, 51, 61, 62, 63, 64, 65], left: [51, 55], right: [61, 65]},
        selectTow: {
          range: [18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28],
          left: [11, 18],
          right: [21, 28]
        },
        selectThree: {
          range: [48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38],
          left: [41, 48],
          right: [31, 38]
        },
        selectFour: {range: [85, 84, 83, 82, 81, 71, 72, 73, 74, 75], left: [81, 85], right: [71, 75]}
      }
    };
  },
  props: {
    readOnly: {
      type: Boolean
    },
    commonTeeth: {
      type: Array
    },
    uploadIntervalList: {
      type: Array
    },
    productType: {
      type: String
    },
  },
  computed: {
    ...mapState({
      language: state => state.language,
    }),
    colorMap() {
      const map = {
        irdt: 'purple',
        admin: 'blue',
        clinic: 'blue'
      };
      return map[this.queryPort] || 'blue';   // 默认 big
    },
    selectList() {
      return map(filter(this.commonTeeth, item => item.number && !item.deficiency), it => it.number);
    },
    missingToothList() {
      return filter(this.commonTeeth, item => item.deficiency)
    },
    selectOne() {
      return this.getTeeth('selectOne');
    },
    selectTow() {
      return this.getTeeth('selectTow');
    },
    selectThree() {
      return this.getTeeth('selectThree');
    },
    selectFour() {
      return this.getTeeth('selectFour');
    },
    totalTeeth() {
      return [...this.teethOne, ...this.teethTow, ...this.teethThree, ...this.teethFour];
    },
    commonTeethNew() {
      return this.commonTeeth ? JSON.parse(JSON.stringify(this.commonTeeth)) : [];
    },
    queryPort() {
      return this.$route.query.port;
    }
  },
  watch: {
    commonTeethNew: {
      handler(newValue, old) {
        if ((isArray(newValue) && newValue.length) &&
            (isArray(old) && old.length) && newValue.length < old.length) {
          let list = map(newValue, it => it.number);
          let number;
          each(old, item => {
            if (!list.includes(item.number)) {
              number = item.number
            }
          });
          each(this.teethKey, item => {
            this[item] = map(this[item], it => {
              if (it.nextNumber && it.nextNumber === number || it.number === number) {
                return pickBy(extend({}, it, {nextNumber: '', maintain: '', [it.spacingType]: '', spacingType: ''}))
              }
              return it;
            });
          });
        } else {
          let number, isClickDeficiency;
          let newDeficiencyList = map(filter(newValue, it => it.deficiency), a => a.number);
          let oldDeficiencyList = map(filter(old, it => it.deficiency), a => a.number);
          isClickDeficiency = newDeficiencyList.length > oldDeficiencyList.length;
          if (isClickDeficiency) {
            each(newDeficiencyList, item => {
              if (!oldDeficiencyList.includes(item)) {
                number = item;
              }
            })
          }
          each(this.teethKey, item => {
            this[item] = map(this[item], it => {
              if (it.nextNumber && it.nextNumber === number || it.number === number) {
                return pickBy(extend({}, it, {nextNumber: '', [it.spacingType]: '', spacingType: ''}))
              }
              return it;
            });
          });

          let list = {
            0: 'selectOne',
            1: 'selectTow',
            2: 'selectThree',
            3: 'selectFour',
          };
          each(this.teethKey, (item, index) => {
            this[item] = map(this[item], it => {
              if (it.nextNumber) {
                return {
                  ...it,
                  nextNumber: this.findAdjoinTooth(it.number, this[list[index]])
                }
              }
              return it
            });
          });
        }
      },
      deep: true,
      immediate: true
    },
    uploadIntervalList: {
      handler(val) {
        let list = ['teethOne', 'teethTow', 'teethThree', 'teethFour'];
        if (val.length) {
          if (this.setList) {
            this.teethList = val;
            this.setList = false;
          }
          each(list, listKey => {
            this[listKey] = map(this[listKey], item => {
              let obj = item;
              each(val, it => {
                if (item.number === it.number) {
                  return obj = extend({},
                      item, it,
                      pickBy({width: it.spacingType === '3' ? null : ''}, (it) => it !== ''),
                      pickBy({maintain: it.spacingType === '4' ? 0.01 : ''}, (it) => it !== ''),
                  )
                }
              });
              return obj
            })
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    find,
    getTeeth(quadrantKey) {
      const cfg = this.QUADRANT_MAP[quadrantKey];
      if (!cfg) return [];

      // 1. 只保留本象限可能出现的牙
      let list = this.selectList.filter(n => cfg.range.includes(n));
      // 2. 分左右 + 排序
      const left = list.filter(n => n >= cfg.left[0] && n <= cfg.left[1]).sort((a, b) => b - a);
      const right = list.filter(n => n >= cfg.right[0] && n <= cfg.right[1]).sort((a, b) => a - b);
      return [...left, ...right];
    },
    /* 一条 item 对应的所有 class */
    teethClass(item) {
      const cls = [];           // 最终要绑定的数组
      const pre = this.colorMap;// purple | blue | big

      // 1. 间隙类型 1、2、3
      if (item.spacingType === '1') cls.push(`${pre}_kd`);
      if (item.spacingType === '2') cls.push(`${pre}_sx`);
      if (item.spacingType === '3') cls.push(`${pre}_gb`);

      // 2. maintain 状态
      if (item.maintain) cls.push(`${pre}_wc`);
      if (item?.number == 15) {
        const index = this.selectTow.indexOf(item.number)

        if (this.selectTeethFn(item.number, this.selectFour) ||
            this.selectTeethFn(item.number, this.selectThree) ||
            this.selectTeethFn(item.number, this.selectTow) ||
            this.selectTeethFn(item.number, this.selectOne)) {
          cls.push('curp', 'hvr-bd');
        }
      }
      // 3. 选中高亮（四个列表共用同一个判断函数）
      if (this.selectTeethFn(item.number, this.selectFour) ||
          this.selectTeethFn(item.number, this.selectThree) ||
          this.selectTeethFn(item.number, this.selectTow) ||
          this.selectTeethFn(item.number, this.selectOne)) {
        cls.push('curp', 'hvr-bd');
      }

      return cls;   // 返回数组 Vue 会自动展开成字符串
    },
    popoverHide(index, type, item) {
      if (item && item.spacingType === '' && !item.maintain) {
        this.teethList = filter(this.teethList, it => it.number !== item.number);
        this.$refs[`${type}Popover`][index].doClose();
      }
    },
    teethClick(index, item, type) {
      // doShow()   doClose()
      if (map(this.teethList, it => it.number).includes(item.number)) {
        this.$refs[`${type}Popover`][index].doClose();
        this.teethList = filter(this.teethList, it => it.number !== item.number);
      } else {
        this.teethList.push(item);
        this.$refs[`${type}Popover`][index].doShow();
        //默认打开注释
        // let {number, maintain, spacingType} = item;
        // if(this.selectList.includes(number)){
        //   if(!maintain && !spacingType){
        //     let types = {
        //       one: 'One',
        //       two: 'Tow',
        //       three: 'Three',
        //       four: 'Four'
        //     }[type];
        //     this[`teeth${types}`] = map(this[`teeth${types}`], it => {
        //       if(number === it.number){
        //         return extend({}, it, {spacingType: '1', width: '', nextNumber: this.findAdjoinTooth(number,this[`select${types}`])})
        //       }
        //       return it
        //     })
        //   }
        // }
      }
    },
    // 输入框只能输入数字
    disposeNumber({key, value}) {
      if (value === '') return key.width = '';
      key.width = isNumber(toNumber(value)) && toNumber(value) <= 25 ? toNumber(value) : ''
    },
    // 重置数字
    resetNumber(item, list, index) {
      if (this.readOnly) return;
      if (item.spacingType) {
        this[list][index].spacingType = '';
        this[list][index].width = '';
      }
      if (item.maintain) {
        this[list][index].maintain = '';
      }
    },
    selectTeethFn(number, list) {
      return list.indexOf(number) !== -1 && this.findAdjoinTooth(number, list);
    },
    selectChange(val, item, listType, selectList) {
      if (this.readOnly) return;
      this[listType] = map(this[listType], it => {
        if (item.number === it.number) {
          if (val === 'maintain') {
            return pickBy({
              number: item.number, spacingType: '',
              nextNumber: item.maintain ? '' : this.findAdjoinTooth(item.number, selectList),
              maintain: item.maintain ? null : true
            })
          }
          return pick({
            ...it,
            width: val === '3' || (val === 'maintain' && item[val]) ? null : '',
            spacingType: it.spacingType,
            nextNumber: this.findAdjoinTooth(item.number, selectList),
          }, ['spacingType', 'number', 'width', 'nextNumber'])
        } else {
          return it
        }
      });
      this.$emit('updateInterval',
          filter([...this.teethOne, ...this.teethTow,
            ...this.teethThree, ...this.teethFour], item => item.maintain || item.spacingType))
    },
    findAdjoinTooth(number, list) {
      let index = list.indexOf(number);
      return list[index + 1];
    },
    clearTeeth() {
      each(['teethOne', 'teethTow', 'teethThree', 'teethFour'], list => {
        this[list] = map(this[list], item => {
          return {
            number: item.number,
            spacingType: ''
          }
        });
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.input_mm {
  position: absolute;
  right: 0.2rem;
  top: 0.3rem;
}

.wrap {
  width: 100%;

  .content {
    display: flex;
    justify-content: center;
    margin-bottom: 0.2rem;

    .teeth {
      width: 0.5rem;
      display: flex;
      align-items: center;
      margin-left: 0.1rem;

      .interval_input {
        display: flex;
      }

      span {
        font-size: 0.16rem;
      }

      div {
        margin-left: 0.1rem;
        width: 0.25rem;
        height: 0.25rem;
        border: 0.01rem solid #898989;
        text-align: center;
        line-height: 0.4rem;
        border-radius: 0.05rem;
      }
    }
  }

  .detail {
    padding: 0.16rem 0.2rem;
    width: 100%;
    background-color: #efefef;
    margin: 0 auto;

    p {
      margin-bottom: 0.1rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.input_width {
  margin-top: 0.2rem;
}

.wc_btn {
  width: 1.2rem;
  height: 0.35rem;
  background-color: #fff;
  color: $main_theme_color_333;
  border: 0.01rem solid $main_theme_color_bbb;
  text-align: center;
  line-height: 0.35rem;
  cursor: pointer;
}

.active_btn {
  background-color: $main_theme_color !important;
  color: white;
  border: 0.01rem solid $main_theme_color;
}

.big_kd {
  background-image: url("./img/kd.png");
  border: none !important;
}

.blue_kd {
  background-image: url("./img/blue_kd.png");
  border: none !important;
}

.purple_kd {
  background-image: url("./img/purple_kd.png");
  border: none !important;
}

.big_sx {
  background-image: url("./img/sx.png");
  border: none !important;
}

.blue_sx {
  background-image: url("./img/blue_sx.png");
  border: none !important;
}

.purple_sx {
  background-image: url("./img/purple_sx.png");
  border: none !important;
}

.big_wc {
  background-image: url("./img/wc.png");
  border: none !important;
}

.blue_wc {
  background-image: url("./img/blue_wc.png");
  border: none !important;
}

.purple_wc {
  background-image: url("./img/purple_wc.png");
  border: none !important;
}


.big_gb {
  background-image: url("./img/gb.png");
  border: none !important;
}

.blue_gb {
  background-image: url("./img/blue_gb.png");
  border: none !important;
}

.purple_gb {
  background-image: url("./img/purple_gb.png");
  border: none !important;
}


.com_img {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
</style>